import { render } from "./Female.vue?vue&type=template&id=b875e1ea&scoped=true"
import script from "./Female.vue?vue&type=script&lang=js"
export * from "./Female.vue?vue&type=script&lang=js"

import "./Female.vue?vue&type=style&index=0&id=b875e1ea&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b875e1ea"]])

export default __exports__